import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { ElLoading, ElMessage } from "element-plus";
import { SubmitExamApi } from "@/api/examApi.js";
import { oralAudioApi } from "@/api/oralApi.js";
import { useRoute } from "vue-router";
import { reactive, ref, nextTick, computed, watch } from "vue";
import { useStore } from "vuex";
let route = useRoute();
export default {
  props: ["step", "examInfo", "paperInfo", "article"],
  setup(props, content) {
    let store = useStore();
    let answerData = reactive({
      type: store.state.level.type_self_evaluation,
      paperId: "",
      answer: {}
    });
    let submitFlag = ref(false);
    route = useRoute();
    let articleText = computed(() => {
      let text = "";
      for (let key in props.article) {
        text = props.article[key];
      }
      return text;
    });
    let {
      paper,
      setPaper
    } = usePaper(props.examInfo, props.paperInfo, props.step);
    let {
      play,
      playEnded,
      audioUrl,
      audioStatus,
      pause,
      oralAudio
    } = useAudio(props.examInfo, props.paperInfo, props.step);
    //提交
    function taskEnd() {
      let count = 0;
      for (let key in answerData.answer) {
        if (answerData.answer[key]) count++;
      }
      //有未作答题目
      if (paper.questions.length - count > 0 && !paper.questions[0].play && !paper.questions[0].explain) {
        ElMessage({
          message: `您还有${paper.questions.length - count}题未作答`,
          type: "warning"
        });
        submitFlag.value = true;
      } else if (paper.questions.length - count > 3) {
        ElMessage({
          message: `您还有${paper.questions.length - count - 3}题未作答`,
          type: "warning"
        });
        submitFlag.value = true;
      }
      // 提交
      else {
        if (props.examInfo.examId == "trial") {
          content.emit("selfOver", true);
          return 0;
        }
        let data = {};
        data.relExamId = props.examInfo.examId;
        data.answers = answerData.answer;
        data.submit = 1;
        data.subdivide = props.step == 0 ? 5 : 7;
        data.examId = props.examInfo.examId;
        data.paperId = paper.id;
        const loading = ElLoading.service({
          lock: true,
          text: "提交自评..",
          background: "rgba(0, 0, 0, 0.7)"
        });
        if (route.meta.trial) {
          setTimeout(() => {
            loading.close();
            content.emit("selfOver", true);
          }, 1000);
        } else {
          SubmitExamApi(data).then(r => {
            loading.close();
            if (r.status < 400) {
              content.emit("selfOver", true);
            }
          });
        }
      }
    }
    function setClassName(question) {
      if (question.play || question.explain) {
        return "paper-content-item";
      } else if (answerData.answer[paper.id + "-" + question.id]) {
        return "paper-content-item";
      } else if (submitFlag.value) {
        return "paper-content-item no-answer";
      } else {
        return "paper-content-item";
      }
    }
    watch(() => props.step, () => {
      submitFlag.value = false;
      setPaper(props.step);
      answerData.answer = {};
    }, {
      immediate: true
    });
    return {
      oralAudio,
      articleText,
      play,
      playEnded,
      audioUrl,
      audioStatus,
      pause,
      paper,
      taskEnd,
      answerData,
      setClassName,
      submitFlag
    };
  }
};

//试卷
function usePaper(examInfo, paperInfo) {
  let allPaper = {
    writing_end_self_evaluation_1: {
      id: "writing_end_self_evaluation_1",
      title: "写后自评表一",
      description: "恭喜你完成了写作任务！左下方是你刚才提交的作文，现在请你回顾自己的写作过程，从以下方面进行自我评价。请选择符合你情况的选项。",
      choices: {
        1: "是",
        2: "否",
        3: "不适用"
      },
      questions: [{
        explain: true,
        stem: "在写作前"
      }, {
        id: "1",
        stem: "在写作前，根据写作需要思考采用哪些平时所收集到的有用信息。"
      }, {
        id: "2",
        stem: "在写作前，认真地进行审题，并安排文章的结构和内容。"
      }, {
        id: "3",
        stem: "在写作前，用关键词列出作文的提纲，用以构思作文的内容。"
      }, {
        id: "4",
        stem: "在写作前，列出所给文章的要点和关键词，以帮助自己进行概要写作。"
      }, {
        id: "5",
        stem: "在写作前，站在读者的角度构思了行文风格。"
      }, {
        explain: true,
        stem: "在写作过程中"
      }, {
        id: "6",
        stem: "在文章的开头，使用能引起读者注意的方法，如：提问、引用谚语等。"
      }, {
        id: "7",
        stem: "按照一定的逻辑关系，如：主次、因果、对比等，来组织作文的内容。"
      }, {
        id: "8",
        stem: "写主题句来突出每个段落的主要内容。"
      }, {
        id: "9",
        stem: "使用了举例、对比、解释、说明等方法来展开各个段落。"
      }, {
        id: "10",
        stem: "使用连接词来表示句子与句子间的关系，如：先后顺序、对比、因果、举例等。"
      }, {
        id: "11",
        stem: "使用衔接手段，如指代、替代、省略等，以确保段落与段落之间的自然衔接。"
      }, {
        id: "12",
        stem: "变换使用不同的词语和句法结构来避免表达上的重复和单调。"
      }, {
        id: "13",
        stem: "采用同义词替换或解释的方法来解决写作表达中的困难。"
      }, {
        id: "14",
        stem: "转述或引用他人的观点用以论证自己的观点。"
      }, {
        id: "15",
        stem: "运用表格或图表来说明自己的观点或直观地提供了信息。"
      }, {
        id: "16",
        stem: "使用一些修辞手法，使表达更生动，如：比喻、排比、拟人、反问等。"
      }, {
        id: "17",
        stem: "使用简单的语句来解释抽象的概念。"
      }, {
        id: "18",
        stem: "不按某些写作模板中来写作。"
      }, {
        explain: true,
        stem: "在写作完成后"
      }, {
        id: "19",
        stem: "在写完后，逐字逐句地检查自己的作文，并改正拼写、标点、格式、语法等方面的错误和笔误。"
      }, {
        id: "20",
        stem: "在写完后，根据需要对用词、句子、内容和文章结构进行修改和调整，达到润色的效果。"
      }, {
        id: "21",
        stem: "在写完后，检查自己的作文，改正不恰当的衔接和连贯问题。"
      }, {
        id: "22",
        stem: "在写完后，检查了文章中所引述内容的准确性和恰当性。"
      }]
    },
    writing_end_self_evaluation_2: {
      id: "writing_end_self_evaluation_2",
      title: "写后自评表二",
      description: "左下方是你刚才提交的作文，请从以下方面对这篇作文进行自我评价。请选择符合你情况的选项。",
      choices: {
        1: "符合",
        2: "部分符合",
        3: "不符合"
      },
      questions: [{
        id: "1",
        stem: "我的行文是紧扣主题的。"
      }, {
        id: "2",
        stem: "我的作文所表达的思想具有深刻性。"
      }, {
        id: "3",
        stem: "我的作文是结合我的所见所闻而展开的。"
      }, {
        id: "4",
        stem: "我使用了简单的语句来解释抽象的概念。"
      }, {
        id: "5",
        stem: "我使用的单词是基本正确的。"
      }, {
        id: "6",
        stem: "我所用的单词表达了我想表达的意义。"
      }, {
        id: "7",
        stem: "我所用的词组是搭配得当的。"
      }, {
        id: "8",
        stem: "我使用的时态和语态是正确的。"
      }, {
        id: "9",
        stem: "我使用的各类从句是正确的。"
      }, {
        id: "10",
        stem: "我交叉使用了不同的从句结构。"
      }, {
        id: "11",
        stem: "我所用的倒装句和强调句等结构是正确的。"
      }, {
        id: "12",
        stem: "我变换了不同的用词，以避免行文重复。"
      }, {
        id: "13",
        stem: "我使用了一些我所熟悉的修辞手法（如比喻和拟人）。"
      }, {
        id: "14",
        stem: "我交叉使用了长句和短句。"
      }, {
        id: "15",
        stem: "我交叉使用了简单句和复杂句。"
      }, {
        id: "16",
        stem: "我引用了一些典故或格言。"
      }, {
        id: "17",
        stem: "我使用了衔接手段使句子前后连贯。"
      }, {
        id: "18",
        stem: "我使用了衔接手段使段落前后流畅。"
      }, {
        id: "19",
        stem: "我写出了表达中心意思的中心句。"
      }, {
        id: "20",
        stem: "我在每个段落中都写出了表达段落大意的主题句。"
      }, {
        id: "21",
        stem: "我在每个段落所表达的意义都是清晰直接的。"
      }, {
        id: "22",
        stem: "我的文章有开头部分、中心部分和结尾。"
      }, {
        id: "23",
        stem: "我认为我所使用的标点符号都是正确的。"
      }, {
        id: "24",
        stem: "我在句首或使用专有名词时正确使用了大小写。"
      }, {
        id: "25",
        stem: "我认为我的单词拼写都是正确的。"
      }],
      tongji: {
        content: [1, 2, 3],
        language: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
        organization: [17, 18, 19, 20, 21, 22],
        mechanics: [23, 24, 25]
      }
    },
    writing_end_self_evaluation_trial_1: {
      id: "writing_end_self_evaluation_1",
      title: "写后自评表一",
      description: "恭喜你完成了写作任务！左下方是你刚才提交的作文，现在请你回顾自己的写作过程，从以下方面进行自我评价。请选择符合你情况的选项。",
      choices: {
        1: "是",
        2: "否",
        3: "不适用"
      },
      questions: [{
        id: "1",
        stem: "我根据需要思考了采用哪些平常所收集到的有用信息。",
        task: "在写作前"
      }, {
        id: "2",
        stem: "我认真进行了审题，并安排文章的结构和内容。",
        task: "在写作前"
      }, {
        id: "3",
        stem: "我用关键词列出了作文的提纲，用以构思作文的内容。",
        task: "在写作前"
      }, {
        id: "4",
        stem: "我在文章的开头，使用能引起读者注意的方法，如：提问、引用谚语等。",
        task: "在写作过程中"
      }, {
        id: "5",
        stem: "我按照一定的逻辑关系，如：主次、因果、对比等来组织作文内容。",
        task: "在写作过程中"
      }, {
        id: "6",
        stem: "我写了主题句来突出每个段落的主要内容。",
        task: "在写作过程中"
      }, {
        id: "7",
        stem: "我使用了简单的语句来解释抽象的概念。",
        task: "在写作过程中"
      }, {
        id: "8",
        stem: "我的写作内容不是从某些写作模板中来的。",
        task: "在写作过程中"
      }, {
        id: "9",
        stem: "我逐字逐句地检查了自己的作文，并改正了拼写、标点、格式、语法等方面的错误和笔误。",
        task: "在写完后"
      }, {
        id: "10",
        stem: "我根据需要对用词、句子、内容和文章结构进行了修改和调整，达到润色的效果。",
        task: "在写完后"
      }, {
        id: "11",
        stem: "我检查了自己的作文，改正了不恰当的衔接和连贯问题。",
        task: "在写完后"
      }, {
        id: "12",
        stem: "我检查了文章中所引述内容的准确性和恰当性。",
        task: "在写完后"
      }]
    },
    writing_end_self_evaluation_trial_2: {
      id: "writing_end_self_evaluation_2",
      title: "写后自评表二",
      descriptionOne: "左下方是你刚才提交的作文，请从以下方面对这篇作文进行自我评价。",
      descriptionTwo: "表示你的作文符合该描述语的要求,",
      descriptionThree: "表示你的作文部分符合该描述语的要求,",
      descriptionFour: "表示你的作文不符合该条描述语的要求。请选择符合你情况的选项。",
      choices: {
        1: "符合",
        2: "部分符合",
        3: "不符合"
      },
      choicesdesc: {
        1: "符合",
        2: "部分符合",
        3: "不符合"
      },
      questions: [{
        id: "1",
        stem: "我的行文是紧扣主题的。"
      }, {
        id: "2",
        stem: "我的作文所表达的思想具有深刻性。"
      }, {
        id: "3",
        stem: "我的作文是结合我的所见所闻而展开的。"
      }, {
        id: "4",
        stem: "我使用的单词是基本正确的。"
      }, {
        id: "5",
        stem: "我使用的时态和语态是正确的。"
      }, {
        id: "6",
        stem: "我使用的各类从句是正确的。"
      }, {
        id: "7",
        stem: "我交叉使用了简单句和复杂句。"
      }, {
        id: "8",
        stem: "我引用了一些典故或格言。"
      }, {
        id: "9",
        stem: "我使用了衔接手段使句子前后连贯。"
      }, {
        id: "10",
        stem: "我写出了表达中心意思的中心句。"
      }, {
        id: "11",
        stem: "我认为我所使用的标点符号都是正确的。"
      }, {
        id: "12",
        stem: "我认为我的单词拼写都是正确的。"
      }]
    },
    writing_front_self_evaluation_4: {
      id: "writing_front_self_evaluation_4",
      title: "写前自评表",
      description: "在诊断测试之前，请根据您对自己英语写作能力的了解，选择符合您情况的的选项。",
      choices: {
        1: "完全做不到",
        2: "勉强做到",
        3: "基本做到",
        4: "较好做到"
      },
      questions: [{
        id: "1",
        stem: "在写作中做到用词正确。"
      }, {
        id: "2",
        stem: "在写作中做到词组搭配得当。"
      }, {
        id: "3",
        stem: "正确使用英语中的各种时态和语态。"
      }, {
        id: "4",
        stem: "正确使用英语中的各类从句。"
      }, {
        id: "5",
        stem: "正确使用英语中的一些复杂句式，如倒装句、强调结构等。"
      }, {
        id: "6",
        stem: "规划文章的组织结构，做到层次清楚。"
      }, {
        id: "7",
        stem: "使用不同的衔接手段，做到句子通顺连贯。"
      }, {
        id: "8",
        stem: "在写作中做到段落的连接自然流畅。"
      }, {
        id: "9",
        stem: "在作文中清楚地写出表达中心意思的中心句。"
      }, {
        id: "10",
        stem: "在作文的各个段落中写出表达段落大意的主题句。"
      }, {
        id: "11",
        stem: "在写作中始终紧扣主题展开讨论。"
      }, {
        id: "12",
        stem: "在写作中表达出自己的思想内涵。"
      }, {
        id: "13",
        stem: "在写作中表达清楚的意思，并具有逻辑性。"
      }, {
        id: "14",
        stem: "在写作中正确使用英语中的标点符号。"
      }, {
        id: "15",
        stem: "在写作中做到单词拼写和大小写正确。"
      }, {
        id: "16",
        stem: "变换使用常见单词或词组以避免行文重复。"
      }, {
        id: "17",
        stem: "利用事例来阐述和论证自己的观点。"
      }, {
        id: "18",
        stem: "条例清晰地描述系列图片中的故事情节。"
      }, {
        id: "19",
        stem: "按照故事的开头续写故事的经过和结尾，做到内容连贯。"
      }, {
        id: "20",
        stem: "就自己阅读的书籍写读书报告。"
      }]
    },
    writing_front_self_evaluation_5: {
      id: "writing_front_self_evaluation_5",
      title: "写前自评表",
      description: "在诊断测试之前，请根据您对自己英语写作能力的了解，选择符合您情况的的选项。",
      choices: {
        1: "完全做不到",
        2: "勉强做到",
        3: "基本做到",
        4: "较好做到"
      },
      questions: [{
        id: "1",
        stem: "在写作中做到用词正确。"
      }, {
        id: "2",
        stem: "正确使用英语中的各种时态和语态。"
      }, {
        id: "3",
        stem: "正确使用英语中的一些复杂句式，如倒装句、强调结构等。"
      }, {
        id: "4",
        stem: "在写作中交叉使用长句和短句。"
      }, {
        id: "5",
        stem: "根据交流需要，使用适当的语体和语气来行文。"
      }, {
        id: "6",
        stem: "规划文章的组织结构，做到层次清楚。"
      }, {
        id: "7",
        stem: "在写作中做到段落的连接自然流畅。"
      }, {
        id: "8",
        stem: "在作文中清楚地写出表达中心意思的中心句。"
      }, {
        id: "9",
        stem: "在作文的各个段落中写出表达段落大意的主题句。"
      }, {
        id: "10",
        stem: "就社会热点问题阐述自己的看法。"
      }, {
        id: "11",
        stem: "在写作中表达出自己的思想内涵。"
      }, {
        id: "12",
        stem: "在写作中表达清楚的意思，并具有逻辑性。"
      }, {
        id: "13",
        stem: "在写作中正确使用英语中的标点符号。"
      }, {
        id: "14",
        stem: "在写作中做到单词拼写和大小写正确。"
      }, {
        id: "15",
        stem: "根据需要搜集和整理写作素材。"
      }, {
        id: "16",
        stem: "变换使用常见单词或词组以避免行文重复。"
      }, {
        id: "17",
        stem: "使用一些修辞手法来增强表达效果。"
      }, {
        id: "18",
        stem: "根据需要对措辞、句子和篇章结构进行修改。"
      }, {
        id: "19",
        stem: "对不同来源的信息和论据进行综述和评价。"
      }, {
        id: "20",
        stem: "就自己遭受到的不公正待遇写投诉信。"
      }]
    },
    writing_front_self_evaluation_6: {
      id: "writing_front_self_evaluation_6",
      title: "写前自评表",
      description: "在诊断测试之前，请根据您对自己英语写作能力的了解，选择符合您情况的的选项。",
      choices: {
        1: "完全做不到",
        2: "勉强做到",
        3: "基本做到",
        4: "较好做到"
      },
      questions: [{
        id: "1",
        stem: "在写作中做到词组搭配得当。"
      }, {
        id: "2",
        stem: "正确使用英语中的各类从句。"
      }, {
        id: "3",
        stem: "正确使用英语中的一些复杂句式，如倒装句、强调结构等。"
      }, {
        id: "4",
        stem: "在写作中交叉使用简单句和复杂句。"
      }, {
        id: "5",
        stem: "根据交流需要，使用适当的语体和语气来行文。"
      }, {
        id: "6",
        stem: "规划文章的组织结构，做到层次清楚。"
      }, {
        id: "7",
        stem: "使用不同的衔接手段，做到句子通顺连贯。"
      }, {
        id: "8",
        stem: "在写作中做到段落的连接自然流畅。"
      }, {
        id: "9",
        stem: "在作文的各个段落中写出表达段落大意的主题句。"
      }, {
        id: "10",
        stem: "就某种现象论证自己的观点。"
      }, {
        id: "11",
        stem: "在写作中表达出自己的思想内涵。"
      }, {
        id: "12",
        stem: "在写作中表达清楚的意思，并具有逻辑性。"
      }, {
        id: "13",
        stem: "在写作中正确使用英语中的标点符号。"
      }, {
        id: "14",
        stem: "用简单的语句解释抽象的概念。"
      }, {
        id: "15",
        stem: "使用简单的图表等进行解释或说明。"
      }, {
        id: "16",
        stem: "对不同来源的信息和论据进行综述和评价。"
      }, {
        id: "17",
        stem: "在写作中引用一些典故或格言。"
      }, {
        id: "18",
        stem: "在写作中站在读者的角度来构思我的行文。"
      }, {
        id: "19",
        stem: "就所读的书籍写书评，凸显自己对阅读内容的评价等。"
      }, {
        id: "20",
        stem: "写某一课程的课程论文，反映我对其的理解和思考。"
      }]
    },
    writing_front_self_evaluation_7: {
      id: "writing_front_self_evaluation_7",
      title: "写前自评表",
      description: "在诊断测试之前，请根据您对自己英语写作能力的了解，选择符合您情况的的选项。",
      choices: {
        1: "完全做不到",
        2: "勉强做到",
        3: "基本做到",
        4: "较好做到"
      },
      questions: [{
        id: "1",
        stem: "在写作中做到词组搭配得当。"
      }, {
        id: "2",
        stem: "正确使用英语中的一些复杂句式，如倒装句、强调结构等。"
      }, {
        id: "3",
        stem: "在写作中交叉使用长句和短句。"
      }, {
        id: "4",
        stem: "在写作中交叉使用简单句和复杂句。"
      }, {
        id: "5",
        stem: "根据交流需要，使用适当的语体和语气来行文。"
      }, {
        id: "6",
        stem: "规划文章的组织结构，做到层次清楚。"
      }, {
        id: "7",
        stem: "把握好作文中不同段落间的逻辑关系。"
      }, {
        id: "8",
        stem: "在作文中清楚地写出表达中心意思的中心句。"
      }, {
        id: "9",
        stem: "在作文的各个段落中写出表达段落大意的主题句。"
      }, {
        id: "10",
        stem: "就社会热点问题阐述自己的看法。"
      }, {
        id: "11",
        stem: "在写作中始终紧扣主题展开讨论。"
      }, {
        id: "12",
        stem: "在写作中表达清楚的意思，并具有逻辑性。"
      }, {
        id: "13",
        stem: "在写作中正确使用英语中的标点符号。"
      }, {
        id: "14",
        stem: "根据需要搜集和整理写作素材。"
      }, {
        id: "15",
        stem: "用简单的语句解释抽象的概念。"
      }, {
        id: "16",
        stem: "使用一些修辞手法来增强表达效果。"
      }, {
        id: "17",
        stem: "使用简单的图表等进行解释或说明。"
      }, {
        id: "18",
        stem: "根据需要对措辞、句子和篇章结构进行修改。"
      }, {
        id: "19",
        stem: "用英语撰写学位论文，基本符合学术规范。"
      }, {
        id: "20",
        stem: "在老师或者同学的帮助下进行简单的文学创作，如短篇小说等。"
      }]
    },
    writing_front_self_evaluation_trial: {
      id: "writing_front_self_evaluation_4",
      title: "写前自评表快速体验",
      description: "在我们诊断你的英语写作能力之前，我们想先了解一下你的情况。请根据你对自己英语写作能力的了解，选择符合你情况的的选项。",
      choices: {
        1: "完全做不到",
        2: "勉强做到",
        3: "基本做到",
        4: "较好做到"
      },
      questions: [{
        id: "1",
        stem: "我能在写作中做到词组搭配得当。"
      }, {
        id: "2",
        stem: "我能正确使用英语中的各种时态和语态。"
      }, {
        id: "3",
        stem: "我能正确使用英语中的各类从句。"
      }, {
        id: "4",
        stem: "我能规划文章的组织结构，做到层次清楚。"
      }, {
        id: "5",
        stem: "我能使用不同的衔接手段，做到句子通顺连贯。"
      }, {
        id: "6",
        stem: "我能在写作中表达出自己的思想内涵。"
      }, {
        id: "7",
        stem: "我能在写作中表达清楚的意思，并具有逻辑性。"
      }, {
        id: "8",
        stem: "我能在写作中正确使用英语中的标点符号。"
      }, {
        id: "9",
        stem: "我能在写作中做到单词拼写和大小写正确。"
      }, {
        id: "10",
        stem: "我能利用事例来阐述和论证自己的观点。"
      }, {
        id: "11",
        stem: "按照故事的开头续写故事的经过和结尾，做到内容连贯。"
      }]
    },
    oral_front_self_evaluation: {
      id: "oral_front_self_evaluation",
      title: "考前自评表",
      description: "请逐条阅读以下能力描述语，并根据你对自己英语口语能力的判断，选择你能做到的程度。",
      choices: {
        1: "完全做不到",
        2: "勉强做到",
        3: "基本做到",
        4: "较好做到"
      },
      questions: [{
        id: "1",
        stem: "我能在朗读时准确地读出单词的发音。"
      }, {
        id: "2",
        stem: "我能在朗读时将句子划分成恰当的意群。"
      }, {
        id: "3",
        stem: "我能有意识地使用不同的语调，如用恰当的语调进行提问或表达疑惑。"
      }, {
        id: "4",
        stem: "我能使用重读和弱读传递信息，如通过句子重音强调特定意义。"
      }, {
        id: "5",
        stem: "我能够紧扣给定主题进行表达。"
      }, {
        id: "6",
        stem: "我能有意识地描述相关细节，使表达内容更加丰富。"
      }, {
        id: "7",
        stem: "我能有意识地使用丰富的论据（如举例子或数据等），使表达更有说服力。"
      }, {
        id: "8",
        stem: "我能就特定话题发表有一定深度的个人见解/评论，做到语言丰富、表达流畅、思路清晰。"
      }, {
        id: "9",
        stem: "我能使用适当的衔接手段表示对比、因果、递进或转折，使表达连贯、有条理。"
      }, {
        id: "10",
        stem: "我能较为完整且连贯地表达出自己的想法。"
      }, {
        id: "11",
        stem: "我能按特定的逻辑顺序简要描述事件或陈述观点。"
      }, {
        id: "12",
        stem: "我能在表达时做到用词准确。"
      }, {
        id: "13",
        stem: "我能有意识地使用丰富/复杂的词汇，使表达更加生动。"
      }, {
        id: "14",
        stem: "我能在表达中遵循语法规则，避免语法错误。"
      }, {
        id: "15",
        stem: "我能有效使用丰富多变的句式（简单句、复杂句、不同类型的复合句），使表达更加生动。"
      }, {
        id: "16",
        stem: "我能有意识地减少不必要的停顿/重复，使表达更加流畅。"
      }, {
        id: "17",
        stem: "我能够在表达中及时发现并纠正自己的语法/用词错误。"
      }, {
        id: "18",
        stem: "我能使用各种口头表达策略克服表达中遇到的困难（如使用um, mmmm, er等填充词赢得思考时间，使用解释、换个说法等手段来处理遇到的表达障碍等）。"
      }, {
        id: "19",
        stem: "我能够注意表达的得体性，使语言表达合乎所处的交际语境。"
      }],
      tongji: {
        phonics: [1, 2, 3, 4],
        content: [5, 6, 7, 8],
        organization: [9, 10, 11],
        language: [12, 13, 14, 15],
        fluency: [16, 17, 18, 19]
      }
    },
    oral_end_self_evaluation_4: {
      id: "oral_end_self_evaluation_4",
      title: "口语考后自评表",
      description: "请逐条阅读以下描述语，判断并选择你所做到的程度。",
      choices: {
        1: "完全未做到",
        2: "勉强做到",
        3: "基本做到",
        4: "较好做到"
      },
      questions: [{
        id: 0,
        stem: "任务3",
        play: true
      }, {
        id: "1",
        stem: "我完整地朗读了整个文段。",
        task: "任务3"
      }, {
        id: "2",
        stem: "我发音准确地读出了每一个单词。",
        task: "任务3"
      }, {
        id: "3",
        stem: "我把句子划分成恰当的意群来朗读。",
        task: "任务3"
      }, {
        id: "4",
        stem: "我恰当使用了不同的语调，使朗读自然动听。",
        task: "任务3"
      }, {
        id: "5",
        stem: "我恰当使用了重音和弱读。",
        task: "任务3"
      }, {
        id: 1,
        stem: "任务4",
        play: true
      }, {
        id: "6",
        stem: "我在复述中涵盖了文段的主要信息点。",
        task: "任务4"
      }, {
        id: "7",
        stem: "我使用了表示对比、因果、递进或转折的衔接手段，使表达连贯、有条理。",
        task: "任务4"
      }, {
        id: "8",
        stem: "我在复述中避免了语法错误。",
        task: "任务4"
      }, {
        id: "9",
        stem: "我在复述中做到了用词准确。",
        task: "任务4"
      }, {
        id: "10",
        stem: "我使用了口头表达策略克服表达中遇到的困难（如用解释、换个说法等手段来处理所遇到的表达障碍）。",
        task: "任务4"
      }, {
        id: 2,
        stem: "任务5",
        play: true
      }, {
        id: "11",
        stem: "我按特定的逻辑顺序描述了六幅图片呈现的主要内容。",
        task: "任务5"
      }, {
        id: "12",
        stem: "我展开描述了相关细节信息。",
        task: "任务5"
      }, {
        id: "13",
        stem: "我使用了衔接手段使表达富有条理。",
        task: "任务5"
      }, {
        id: "14",
        stem: "我使用了多种句式(简单句、复杂句、不同类型的复合句等)。",
        task: "任务5"
      }, {
        id: "15",
        stem: "我使用了丰富、复杂的词汇，使表达更加生动。",
        task: "任务5"
      }, {
        id: "16",
        stem: "我避免了不必要的停顿和重复，表达流利。",
        task: "任务5"
      }, {
        id: "17",
        stem: "我在无法做到准确用词时，使用了其他较为简单或意思相近的词语进行了替代。",
        task: "任务5"
      }, {
        id: "18",
        stem: "我在表达过程中及时发现并纠正了时态使用方面的错误。",
        task: "任务5"
      }, {
        id: "19",
        stem: "我使用了口头表达策略以克服表达中遇到的困难（如使用um, mmmm, er等填充词赢得思考时间）。",
        task: "任务5"
      }],
      tongji: {
        phonics: [1, 2, 3, 4, 5],
        content: [6, 11, 12],
        organization: [7, 13],
        language: [8, 9, 14, 15],
        fluency: [16, 17, 18, 19],
        task3: [1, 2, 3, 4, 5],
        task4: [6, 7, 8, 9, 10],
        task5: [11, 12, 13, 14, 15, 16, 17, 18, 19]
      }
    },
    oral_end_self_evaluation_5: {
      id: "oral_end_self_evaluation_5",
      title: "口语考后自评表",
      description: "请逐条阅读以下描述语，判断并选择你所做到的程度。",
      choices: {
        1: "完全未做到",
        2: "勉强做到",
        3: "基本做到",
        4: "较好做到"
      },
      questions: [{
        id: 0,
        stem: "任务3",
        play: true
      }, {
        id: "1",
        stem: "我完整地朗读了整个文段。",
        task: "任务3"
      }, {
        id: "2",
        stem: "我发音准确地读出了每一个单词。",
        task: "任务3"
      }, {
        id: "3",
        stem: "我把句子划分成恰当的意群来朗读。",
        task: "任务3"
      }, {
        id: "4",
        stem: "我恰当使用了不同的语调，使朗读自然动听。",
        task: "任务3"
      }, {
        id: "5",
        stem: "我恰当使用了重音和弱读。",
        task: "任务3"
      }, {
        id: 1,
        stem: "任务4",
        play: true
      }, {
        id: "6",
        stem: "我按一定的逻辑顺序描述了图片呈现的主要内容。",
        task: "任务4"
      }, {
        id: "7",
        stem: "我充分表达了自己对图片所描述现象的看法，并使用恰当的论据支撑了自己的观点。",
        task: "任务4"
      }, {
        id: "8",
        stem: "我较为完整且连贯地表达了出自己的想法。",
        task: "任务4"
      }, {
        id: "9",
        stem: "我在表达中使用了多种句式(简单句、复杂句、不同类型的复合句等)。",
        task: "任务4"
      }, {
        id: "10",
        stem: "我使用了丰富、复杂的词汇，使表达更加生动。",
        task: "任务4"
      }, {
        id: "11",
        stem: "我避免了不必要的停顿和重复，表达流利。",
        task: "任务4"
      }, {
        id: "12",
        stem: "我在无法做到准确用词时，使用了其他较为简单或意思相近的词语进行了替代。",
        task: "任务4"
      }, {
        id: "13",
        stem: "我在描述相关情景时，及时发现并纠正了时态使用方面的错误。",
        task: "任务4"
      }, {
        id: 2,
        stem: "任务5",
        play: true
      }, {
        id: "14",
        stem: "我所表达的内容均与给定话题密切相关。",
        task: "任务5"
      }, {
        id: "15",
        stem: "我有意识地使用了丰富的论据（如实例、数据等），使表达更有说服力。",
        task: "任务5"
      }, {
        id: "16",
        stem: "我就给定话题发表了有一定深度的个人见解，做到了语言丰富、表达流畅、思路清晰。",
        task: "任务5"
      }, {
        id: "17",
        stem: "我陈述观点时遵循了特定的逻辑顺序。",
        task: "任务5"
      }, {
        id: "18",
        stem: "我使用了一些衔接手段，使表达连贯、自然、条理清晰。",
        task: "任务5"
      }, {
        id: "19",
        stem: "我在表达中避免了语法错误。",
        task: "任务5"
      }, {
        id: "20",
        stem: "我在表达中做到了用词准确。",
        task: "任务5"
      }, {
        id: "21",
        stem: "我使用了口头表达策略克服表达中遇到的困难（如使用um, mmmm, er等填充词赢得思考时间）。",
        task: "任务5"
      }, {
        id: "22",
        stem: "我在表达遇到困难时，使用了释义、举例、按字面翻译等方法，迂回地表明意思。",
        task: "任务5"
      }],
      tongji: {
        phonics: [1, 2, 3, 4, 5],
        content: [6, 7, 14, 15, 16],
        organization: [8, 17, 18],
        language: [9, 10, 19, 20],
        fluency: [11, 12, 13, 21, 22],
        task3: [1, 2, 3, 4, 5],
        task4: [6, 7, 8, 9, 10, 11, 12, 13],
        task5: [14, 15, 16, 17, 18, 19, 20, 21, 22]
      }
    },
    oral_end_self_evaluation_6: {
      id: "oral_end_self_evaluation_6",
      title: "口语考后自评表",
      description: "请逐条阅读以下描述语，判断并选择你所做到的程度。",
      choices: {
        1: "完全未做到",
        2: "勉强做到",
        3: "基本做到",
        4: "较好做到"
      },
      questions: [{
        id: 0,
        stem: "任务3",
        play: true
      }, {
        id: "1",
        stem: "我完整地朗读了整个文段。",
        task: "任务3"
      }, {
        id: "2",
        stem: "我发音准确地读出了每一个单词。",
        task: "任务3"
      }, {
        id: "3",
        stem: "我把句子划分成恰当的意群来朗读。",
        task: "任务3"
      }, {
        id: "4",
        stem: "我恰当使用了不同的语调，使朗读自然动听。",
        task: "任务3"
      }, {
        id: "5",
        stem: "我恰当使用了重音和弱读。",
        task: "任务3"
      }, {
        id: 1,
        stem: "任务4",
        play: true
      }, {
        id: "6",
        stem: "我准确地描述了图表传达出的信息。",
        task: "任务4"
      }, {
        id: "7",
        stem: "我对图表中的数据进行了认真的思考和分析。",
        task: "任务4"
      }, {
        id: "8",
        stem: "我对图表传达出的信息进行了有一定深度的评论。",
        task: "任务4"
      }, {
        id: "9",
        stem: "我使用了一些表示对比、因果、递进或转折的衔接手段，使表达连贯、有条理。",
        task: "任务4"
      }, {
        id: "10",
        stem: "我在表达中避免了语法错误。",
        task: "任务4"
      }, {
        id: "11",
        stem: "我在表达中做到了用词准确。",
        task: "任务4"
      }, {
        id: "12",
        stem: "我避免了不必要的停顿和重复，表达流利。",
        task: "任务4"
      }, {
        id: "13",
        stem: "我在无法做到准确用词时，使用了其他较为简单或意思相近的词语进行了替代。",
        task: "任务4"
      }, {
        id: "14",
        stem: "我在描述图表时，及时发现并纠正了时态使用方面的错误。",
        task: "任务4"
      }, {
        id: 2,
        stem: "任务5",
        play: true
      }, {
        id: "15",
        stem: "我认真分析了给定问题，并明确阐释了自己的立场。",
        task: "任务5"
      }, {
        id: "16",
        stem: "我有效使用了多种论据（如实例、数据等）充分论证和支撑自己的观点。",
        task: "任务5"
      }, {
        id: "17",
        stem: "我使用了一些衔接手段，使表达连贯、自然、条理清晰。",
        task: "任务5"
      }, {
        id: "18",
        stem: "我在表达中做到了各观点之间逻辑清晰、层次分明。",
        task: "任务5"
      }, {
        id: "19",
        stem: "我在表达观点时，使用了典型的演说模式，如介绍、论述、下结论等。",
        task: "任务5"
      }, {
        id: "20",
        stem: "我在表达中使用了多种句式(简单句、复杂句、不同类型的从句等)。",
        task: "任务5"
      }, {
        id: "21",
        stem: "我使用了丰富、复杂的词汇，使表达更加生动。",
        task: "任务5"
      }, {
        id: "22",
        stem: "我使用了口头表达策略克服表达中遇到的困难（如使用um, mmmm, er等填充词赢得思考时间）。",
        task: "任务5"
      }, {
        id: "23",
        stem: "我在表达遇到困难时，使用了释义、举例、按字面翻译等方法，迂回地表明意思。",
        task: "任务5"
      }, {
        id: "24",
        stem: "我在表达中及时发现并纠正了时态使用方面的错误。",
        task: "任务5"
      }],
      tongji: {
        phonics: [1, 2, 3, 4, 5],
        content: [6, 7, 8, 15, 16],
        organization: [9, 17, 18, 19],
        language: [10, 11, 20, 21],
        fluency: [12, 13, 14, 22, 23, 24],
        task3: [1, 2, 3, 4, 5],
        task4: [6, 7, 8, 9, 10, 11, 12, 13, 14],
        task5: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24]
      }
    },
    oral_end_self_evaluation_7: {
      id: "oral_end_self_evaluation_7",
      title: "口语考后自评表",
      description: '请您回顾口语作答情况并对自己的表现进行客观的评价。点击<img src="image/audioplay-red.svg">可回听您的作答音频。<br/> 1=基本做不到 2=勉强能做到 3=基本能做到 4=轻松能做到 5=完全能做到',
      choices: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5"
      },
      questions: [{
        id: "1",
        stem: "在“任务一：朗读”中，我能够准确读出每一个单词。"
      }, {
        id: "2",
        stem: "在“任务一：朗读”中，我有意识地使用重音或弱读。"
      }, {
        id: "3",
        stem: "在“任务一：朗读”中，我有意识地使用语调来表达意义。"
      }, {
        id: "4",
        stem: "在“任务二：复述”中，我能够将文段的主要信息点复述出来。"
      }, {
        id: "5",
        stem: "在“任务二：复述”中，我能够将文段的主要信息点复述出来。"
      }, {
        id: "6",
        stem: "在“任务三：图片描述”中，我能将四幅图的内容连贯地表达出来。"
      }, {
        id: "7",
        stem: "我有意识地减少使用“um,mmmm,er”这样的词，使表达流畅。"
      }, {
        id: "8",
        stem: "我能够使用正确的语法形式。"
      }, {
        id: "9",
        stem: "我有意识地使用多样化的句式，使表达生动。"
      }, {
        id: "10",
        stem: "我的词汇使用准确。"
      }, {
        id: "11",
        stem: "我有意识地使用丰富的词汇，使表达生动。"
      }, {
        id: "12",
        stem: "我有意识地使用复杂的词汇，使表达更有水平。"
      }, {
        id: "13",
        stem: "我能有效使用衔接手段，使表达连贯自然。"
      }]
    },
    oral_front_self_evaluation_trial: {
      id: "oral_front_trial",
      title: "考前自评表",
      description: "请逐条阅读以下能力描述语，并根据你对自己英语口语能力的判断，选择你能做到的程度。",
      choices: {
        1: "完全做不到",
        2: "勉强做到",
        3: "基本做到",
        4: "较好做到"
      },
      questions: [{
        id: "1",
        stem: "我能有意识地使用不同的语调，如用恰当的语调进行提问或表达疑惑。"
      }, {
        id: "2",
        stem: "我能有意识地使用丰富的论据（如举例子或数据等），使表达更有说服力。"
      }, {
        id: "3",
        stem: "我能使用适当的衔接手段表示对比、因果、递进或转折，使表达连贯、有条理。"
      }, {
        id: "4",
        stem: "我能有意识地使用丰富/复杂的词汇，使表达更加生动。"
      }, {
        id: "5",
        stem: "我能够在表达中及时发现并纠正自己的语法/用词错误。"
      }]
    },
    oral_end_self_evaluation_trial: {
      id: "oral_end_trial",
      title: "口语考后自评表",
      description: "请逐条阅读以下描述语，判断并选择你所做到的程度。",
      choices: {
        1: "完全未做到",
        2: "勉强做到",
        3: "基本做到",
        4: "较好做到"
      },
      questions: [{
        id: "1",
        stem: "我发音准确地读出了每一个单词。",
        task: "任务1"
      }, {
        id: "2",
        stem: "我恰当使用了不同的语调，使朗读自然动听。",
        task: "任务1"
      }, {
        id: "3",
        stem: "我在复述中涵盖了句子的主要信息点。",
        task: "任务2"
      }, {
        id: "4",
        stem: "我在复述中避免了语法错误。",
        task: "任务2"
      }, {
        id: "5",
        stem: "我在复述中做到了用词准确。",
        task: "任务2"
      }, {
        id: "6",
        stem: "我充分表达了自己对图片所描述现象的看法，并使用恰当的论据支撑了自己的观点。",
        task: "任务3"
      }, {
        id: "7",
        stem: "我较为完整且连贯地表达了出自己的想法。",
        task: "任务3"
      }, {
        id: "8",
        stem: "我使用了丰富、复杂的词汇，使表达更加生动。",
        task: "任务3"
      }, {
        id: "9",
        stem: "我避免了不必要的停顿和重复，表达流利。",
        task: "任务3"
      }],
      tongji: {
        phonics: [1, 2],
        content: [3, 6],
        organization: [7],
        language: [4, 5, 8],
        fluency: [9],
        task1: [1, 2],
        task2: [3, 4, 5],
        task3: [6, 7, 8, 9]
      }
    }
  };
  let paper = reactive({});
  function getPaper(step) {
    if (examInfo.skill == "S4") {
      if (route.meta.trial) {
        if (step == 0) {
          return allPaper["writing_front_self_evaluation_trial"];
        } else if (step == 3) {
          return allPaper["writing_end_self_evaluation_trial_1"];
        } else if (step == 4) {
          return allPaper["writing_end_self_evaluation_trial_2"];
        }
      } else {
        if (step == 0) {
          return allPaper["writing_front_self_evaluation_" + (paperInfo.level ? paperInfo.level : 4)];
        } else if (step == 3) {
          return allPaper["writing_end_self_evaluation_1"];
        } else if (step == 4) {
          return allPaper["writing_end_self_evaluation_2"];
        }
      }
    } else if (examInfo.skill == "S5") {
      if (step == 0) {
        return route.meta.trial ? allPaper["oral_front_self_evaluation_trial"] : allPaper["oral_front_self_evaluation"];
      } else if (step == 3) {
        return route.meta.trial ? allPaper["oral_end_self_evaluation_trial"] : allPaper["oral_end_self_evaluation_" + paperInfo.level];
      }
    }
  }
  function setPaper(step) {
    Object.assign(paper, getPaper(step));
  }
  return {
    paper,
    setPaper
  };
}
//播放功能
function useAudio(examInfo, paperInfo, step) {
  let audioStatus = reactive(["pause", "pause", "pause"]);
  let audioUrl = ref("");
  let oralAudio = ["", "", ""];
  function play(id) {
    //继续播放
    if (audioUrl.value == oralAudio[id].url) {
      document.getElementById("audio").play();
      audioStatus.splice(id, 1, "ing");
      return 0;
    }
    //播放其它
    for (let i = 0; i < 3; i++) {
      audioStatus.splice(i, 1, "pause");
    }
    audioStatus.splice(id, 1, "ing");
    document.getElementById("audio").pause();
    audioUrl.value = oralAudio[id].url;
    nextTick(() => {
      document.getElementById("audio").load();
      setTimeout(() => {
        document.getElementById("audio").play();
      }, 100);
    });
  }
  function pause(id) {
    audioStatus.splice(id, 1, "pause");
    document.getElementById("audio").pause();
  }
  function playEnded() {
    for (let i = 0; i < 3; i++) {
      audioStatus.splice(i, 1, "pause");
    }
  }
  if (examInfo.skill == "S5" && step > 0 && !route.meta.trial) {
    oralAudioApi({
      examId: examInfo.examId,
      paperId: paperInfo.paperId
    }).then(audioR => {
      audioR.data.forEach(item => {
        oralAudio.splice(item.sortkey, 1, item);
      });
    });
  }
  return {
    play,
    playEnded,
    audioUrl,
    audioStatus,
    pause,
    oralAudio
  };
}